module.exports = __webpack_public_path__ + "static/media/bottom.7fccd8ff.png";